export default __webpack_public_path__ + "static/email-templates-preview-action-22fb56e901c46b034e57e9182b00d39f.mp4";